import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../../common/constants';
import AttendanceTracker from './AttendanceTracker';
import './attendance-tracker.less';

function AttendanceTrackerWrapper() {
  return (
    <Switch>
      <Route
        exact
        path={ROUTES?.AOS_ATTENDANCE_TRACKER}
        component={AttendanceTracker}
      />
    </Switch>
  );
}

export default AttendanceTrackerWrapper;
